import React, { useState } from 'react';
import './PermissionCategory.scss';
import PermissionRow from './PermissionRow/PermissionRow';
import {
    GetRolePermissions_getPermissionRoles_categories as PermissionCategories,
    GetRolePermissions_getPermissionRoles_categories_permissions as PermissionRole,
} from '../../../../types/schemaTypes';

interface PermissionCategoryProps {
    category: PermissionCategories;
    onChange: (roleId: number, permissionId: number, checkedStatus: boolean) => void;
}

const PermissionCategory = ({ category, onChange }: PermissionCategoryProps): React.ReactElement => {
    const [isHidden, setIsHidden] = useState(false);

    return (
        <div className="PermissionCategory-CategoryMenu">
            <div className="PermissionCategory-CategoryName" onClick={() => setIsHidden(!isHidden)}>
                <div>{category.name}</div>
            </div>
            <div className={isHidden ? 'PermissionCategory-Hidden' : 'PermissionCategory-Show'}>
                {category.permissions.map((permission: PermissionRole) => (
                    <PermissionRow key={permission.id} permissionRole={permission} onChange={onChange} />
                ))}
            </div>
        </div>
    );
};

export default PermissionCategory;
